export const STRATEGIES_GET_STRATEGIES = "strategies/get-strategies";
